import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f57f409"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-goods-drawer-content" }
const _hoisted_2 = {
  key: 0,
  class: "btn-sync"
}
const _hoisted_3 = { class: "api-goods-drawer-search flex-center" }
const _hoisted_4 = { class: "goods-content" }

import { t } from '@/plugins/i18n'
import Search from '../Search.vue'
import ProductList from '../ProductList.vue'
import Drawer from '@/components/common/Drawer.vue'
import { ref, computed } from 'vue'
import useShopProduct from './useProduct'
import { searchShopProduct, syncAllGoods } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  emits: ['change'],
  setup(__props, { expose, emit: emits }) {

const store = useStore()
const curshop = computed(() => store.getters.shopInfo)

const [syncLoading, syncApi] = useRequest(syncAllGoods)
const setSyncProduct = async () => {
  const unbind = await confirmApiUnbind()
  if (unbind) return
  syncApi().then((res: any) => {
    if (res.success) {
      ElMessage.success(t('同步成功'))
      shopProductListApi()
    }
  })
}
const keyword = ref('')
const visible = ref(false)
const showProduct = ref(true)
const refresh = () => { }
const close = () => {
  visible.value = false
}
const open = (key: string) => {
  keyword.value = key
  visible.value = true
  shopProductListApi()
}
expose({
  open
})

const shopParams = computed(() => {
  return {
    thirdItemName: keyword.value
  }
})

// 查询获取店铺商品列表数据
const [
  shopProductLoading,
  shopProductPageData,
  shopProductList,
  shopProductTotal,
  shopProductListApi
] = useShopProduct(shopParams, searchShopProduct)
const reset = () => {
  keyword.value = ''
  shopProductListApi()
}
const search = () => {
  shopProductListApi()
}

const selectRow = (e: { shopItemId: string }) => {
  emits('change', e.shopItemId)
  visible.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Drawer, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    onBeforeClose: close,
    onOk: close,
    title: _unref(t)('选择销售商品'),
    showBtn: false,
    size: "1000px",
    className: "api-goods-drawer-components"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(curshop).customerShopPlatform !== 7)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                class: "btn",
                onClick: setSyncProduct,
                loading: _unref(syncLoading)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('同步商品')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Search, {
            style: {"flex":"1"},
            value: keyword.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            onSearch: search
          }, null, 8, ["value"]),
          _createVNode(_component_el_button, {
            class: "reset-btn",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('重置2')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(ProductList, {
            ref: (_value, _refs) => {
              _refs['productRef'] = _value
            },
            data: _unref(shopProductList),
            pageData: _unref(shopProductPageData),
            "onUpdate:pageData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(shopProductPageData) ? (shopProductPageData).value = $event : null)),
            total: _unref(shopProductTotal),
            onRefresh: _unref(shopProductListApi),
            onSelectRow: selectRow,
            type: "api"
          }, null, 8, ["data", "pageData", "total", "onRefresh"]), [
            [_vShow, showProduct.value],
            [_directive_loading, _unref(shopProductLoading)]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})